'use es6';

import { cleanObject } from '../utils/formatters';
import uniqueId from 'hs-lodash/uniqueId';
import Immutable from 'immutable';
const EMPTY_LIST = Immutable.List();
export default class IntegrationFeature extends Immutable.Record({
  headline: '',
  imageUrl: '',
  text: '',
  hubSpotFeatures: EMPTY_LIST,
  id: ''
}) {
  constructor(values) {
    const data = Object.assign({}, values);
    if (values && values.hubSpotFeatures) {
      data.hubSpotFeatures = Immutable.List(values.hubSpotFeatures);
    }
    super(Object.assign({}, cleanObject(data), {
      id: uniqueId('integration-feature-')
    }));
  }

  // 'id' is used as a unique key that persists as the record updates, for ListTransition
  equals(otherObj) {
    return this.delete('id').toString() === otherObj.delete('id').toString();
  }
}